let $ = require("./jquery");
module.exports = function(blockName, callbackFunction) {
    if ($(blockName).length>0) {
        callbackFunction($(blockName));
    }
};
